import ExpertJourneysList from '@components/expert/ExpertJourneysList';
import ExpertTablesPage from '@components/pageTypes/ExpertTablesPage';

type Props = {
  expertId: string;
};

const ExpertManageExpertJourneysPage = ({ expertId }: Props) => (
  <ExpertTablesPage helmetKey="pageTitles.expert.expert.journeyList">
    <ExpertJourneysList expertId={expertId} />
  </ExpertTablesPage>
);

export default ExpertManageExpertJourneysPage;
